// services/paymentService.js
import axios from "axios";
import { urlBase } from "./config";

export async function getPaymentConfig(id, token) {
  try {
    const response = await axios.get(
      `${urlBase}/events/${id}/payments/config`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar configuração de pagamento:", error);
    throw error;
  }
}

export async function postPaymentConfig(token, body) {
  try {
    const response = await axios.post(`${urlBase}/payments/config`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar configuração de pagamento:", error);
    throw error;
  }
}

export async function postTicketSales(token, body) {
  try {
    const response = await axios.post(
      `https://github-api.sistemasinteegra.com.br/ticketsales`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao enviar dados para Ticket Sales:", error);
    throw error;
  }
}

export async function putPaymentConfig(token, id, body) {
  try {
    const response = await axios.put(`${urlBase}/payments/config/${id}`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar configuração de pagamento:", error);
    throw error;
  }
}
